import { Checkbox, Textarea, Typography } from '@design-system';

import './AuditItems.scss';
import { Audit, AuditItem } from '@services/securityAudit/securityAudit.types';

export type AuditItemsProps = {
    title: string;
    description?: string;
    onChange: (itemId: number, compliant: AuditItem['compliant']) => void;
    onCommentChange?: (itemId: number, comment: string) => void;
    items: Audit['items'];
    disabled?: boolean;
    callback?: () => void;
};

export const AuditItems: React.FC<AuditItemsProps> = ({ title, description, onChange, onCommentChange, items, disabled, callback }) => {
    return (
        <div className="audit-items" onClick={callback}>
            <Typography intrinsic="h2" className={`${description ? 'mb-small-spacing' : 'mb-medium-spacing'}`}>
                {title}
            </Typography>
            {description && (
                <Typography intrinsic="p" className="mb-medium-spacing">
                    {description}
                </Typography>
            )}

            {items.map((item) => (
                <div className="audit-item" key={item.id}>
                    <Typography intrinsic="h4" className="mb-small-spacing">
                        {item.label}
                    </Typography>
                    <div className="audit-checkboxes">
                        <Checkbox
                            success
                            checked={item.compliant === 'Conforme'}
                            onChange={() => onChange(item.id, 'Conforme')}
                            label="Conforme"
                            disabled={disabled}
                        />
                        <Checkbox
                            cross
                            checked={item.compliant === 'Non conforme'}
                            onChange={() => onChange(item.id, 'Non conforme')}
                            label="Non conforme"
                            disabled={disabled}
                        />
                        <Checkbox
                            neutral
                            checked={item.compliant === 'Non concerné'}
                            onChange={() => onChange(item.id, 'Non concerné')}
                            label="Non concerné"
                            disabled={disabled}
                        />
                    </div>
                    {item.compliant === 'Non conforme' && onCommentChange && (
                        <div className="audit-comment">
                            <Textarea
                                placeholder="Décrivez ce qui ne va pas..."
                                value={item.comment || ''}
                                onValueChange={(comment: string) => onCommentChange(item.id, comment)}
                                disabled={disabled}
                            />
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};
